import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { Student } from 'src/app/model/student/student.model';

import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { StudentEligibilityCounts } from '../../child-reports/counts/model/student-eligibility-count';
import { UnduplicatedStudentEligibilities } from '../../child-reports/counts/model/unduplicated-student-eligibilities';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { StudentEligibilities } from '../model/student-eligibilities.model';
import { EligibilityStatuses } from '../model/eligibility-statuses.model';
import { EligibilityCategoryTypes } from '../model/eligibility-category-types.model';

@Injectable({
    providedIn: 'root'
})
export class StudentEligibilitiesService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    GetUnduplicatedStudentEligibilities(inputParameter: any): Observable<UnduplicatedStudentEligibilities> {
        //return this.post<any>(EndPoints.unduplicatedStudentEligibilities, false, '', { performancePeriod: '2021-22' }).pipe(
        return this.post<any>(EndPoints.unduplicatedStudentEligibilities, false, '', inputParameter).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    GetStudentEligibilityCountRegion(inputParameter: any): Observable<StudentEligibilityCounts> {
        return this.post<any>(EndPoints.studentEligibilityCount, false, '', inputParameter).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    GetStudentEligibilityCountDistrict(inputParameter: any): Observable<StudentEligibilityCounts> {
        return this.post<any>(EndPoints.studentEligibilityCount, false, '', inputParameter).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    GetUnduplicatedStudentEligibilityCount(inputParameter: any): Observable<UnduplicatedStudentEligibilities> {
        return this.post<any>(EndPoints.unduplicatedStudentEligibilityCount, false, '', inputParameter).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    getLatestCoeAndEligiblity(students: Student[]): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilities_GetLatestCoeAndEligiblity, false, null, {
            students: students
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    indexEligibilityChangeReasonTypes(): Observable<any> {
        return this.get<any>(EndPoints.studentEligibilities_IndexEligibilityChangeReasonTypes, undefined, undefined);
    }

    indexEligibilityStatuses(): Observable<any> {
        return this.get<any>(EndPoints.studentEligibilities_IndexEligibilityStatuses, undefined, undefined);
    }

    indexEligibilityCategoryTypes(): Observable<any> {
        return this.get<any>(EndPoints.studentEligibilities_IndexEligibilityCategoryTypes, undefined, undefined);
    }

    getStudentEligibilities(studentID: number): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilities_GetStudentEligibilities, false, '', { studentID: studentID }).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    getStudentEligibilityByCategory(studentID: number, performancePeriod: string, category: any): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilities_GetStudentEligibilityByCategory, false, '', {
            studentID: studentID,
            performancePeriod: performancePeriod,
            category: category
        }).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    getEiPReason(studentID: number, performancePeriod: string): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilities_GetEiPReason, false, '', { studentID: studentID, performancePeriod: performancePeriod }).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }

    getStudentsByEligibilityCategory(payload: any): Observable<any> {
        return this.post<any>(EndPoints.getStudentsByEligibilityCategory, false, '', {
            eligibilityCategoryType: payload.eligibilityCategoryType,
            performancePeriod: payload.performancePeriod,
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools: payload.chosenSchools
        }).pipe(
            switchMap((result) => {
                return of(JSON.parse(JSON.stringify(result)));
            })
        );
    }
}
